import { route } from 'ziggy-js';
import { useHttp } from '@/Composables/useHttp';

/**
 * Notifies Spectre ID that the user has asked for access to another product.
 * Shared by the layouts that render the product navigation.
 */
export default function useProductAccessRequest() {
  const request = useHttp<{ product: string }>({ product: '' });

  const requestAccess = (product: string): void => {
    request.product = product;

    // Fire-and-forget: the notification is best-effort and there is nothing the
    // user can do about a failure, so swallow rather than leave the rejection
    // unhandled for Sentry to pick up.
    request.post(route('internal-api.request-product-access')).catch(() => {});
  };

  return { requestAccess };
}
